import * as React from 'react';
import "./LabellableComponent.css";
import { IObjectWithKey, ActionButton, IButtonProps, IconButton, IContextualMenuProps, ICalloutProps } from 'office-ui-fabric-react';
import EntityWarning from "../warnings/EntityWarning";
import { IWarning } from "../../../entities/common";
import { InfoHint } from '../InfoableComponent/InfoHint';

export type LabelAction = IButtonProps & IObjectWithKey;

type LabellableComponentProps = {
    className?: string;
    label?: string;
    labelActions?: LabelAction[];
    description?: string | JSX.Element | JSX.Element[];
    required?: boolean;
    onClick?: () => void;
    isConfigureMode?: boolean;
    moreMenuProps?: IContextualMenuProps;
    warnings?: IWarning[];
    tooltipCalloutProps?: ICalloutProps;
}

const LabellableComponent = (props: React.PropsWithChildren<LabellableComponentProps>) => {
    const { label, description, labelActions, warnings, moreMenuProps, tooltipCalloutProps } = props;

    if (!label) {
        return <>{props.children}</>;
    }

    return (
        <div onClick={props.onClick} className={props.className}>
            <div className="field-label-container">
                <div className={`field-label ${props.required ? " required" : ""}`} title={label}>
                    {label}
                </div>
                {
                    description &&
                    <InfoHint description={description} calloutProps={tooltipCalloutProps} />
                }
                {warnings && <EntityWarning warnings={warnings} />}
                {
                    moreMenuProps !== undefined &&
                    <ActionButton menuIconProps={{ iconName: 'More' }}
                        tabIndex={-1}
                        menuProps={moreMenuProps}
                    />
                }
                {labelActions && <div className='align-right'>
                    {labelActions.map(_ => <IconButton {..._}/>)}
                </div>}
            </div>
            {props.children}
        </div>
    );
}
export default LabellableComponent;